// Central definition of every column this widget knows about.
// `defaultVisible: false` means the column is opt-in for a brand-new widget;
import SearchSortType from '../../../../utility/types/SearchSortType';

export const ALERT_LIST_COLUMNS = {
  alertName: {
    label: 'Alert Name', defaultVisible: true, sortType: SearchSortType.ALERT_NAME,
  },
  threshold: {
    label: 'Threshold', defaultVisible: true, sortType: SearchSortType.TRIGGER,
  },
  latestReading: {
    label: 'Latest Reading', defaultVisible: true, sortType: SearchSortType.CURRENT,
  },
  trend24h: { label: '24 Hour Trends', defaultVisible: true },
  source: {
    label: 'Source', defaultVisible: false, sortType: SearchSortType.SOURCE,
  },
  clearValue: {
    label: 'Clear Value', defaultVisible: false, sortType: SearchSortType.CLEAR,
  },
  tag: {
    label: 'Tag', defaultVisible: false, sortType: SearchSortType.TAG,
  },
};

// The canonical column order used by the table.
export const COLUMN_ORDER = [
  'alertName',
  'source',
  'tag',
  'threshold',
  'clearValue',
  'latestReading',
  'trend24h',
];

// Turn `context.disabledColumns` into a { columnId: bool } visibility map.
export const buildColumnVisibility = (disabledColumns) => {
  const useDefaults = disabledColumns == null;
  const disabledSet = new Set(disabledColumns || []);

  const visibility = Object.entries(ALERT_LIST_COLUMNS).reduce((acc, [id, cfg]) => {
    if (useDefaults) {
      acc[id] = cfg.defaultVisible;
    } else {
      acc[id] = !disabledSet.has(id);
    }
    return acc;
  }, {});

  // Guarantee at least one column is visible.
  if (!Object.values(visibility).some(Boolean)) {
    const firstId = COLUMN_ORDER.find((id) => ALERT_LIST_COLUMNS[id])
      || Object.keys(ALERT_LIST_COLUMNS)[0];
    visibility[firstId] = true;
  }
  return visibility;
};

// Given the current visibility map, produce the next `disabledColumns` array
export const toDisabledColumns = (visibility) => Object.entries(visibility)
  .filter(([, isOn]) => !isOn)
  .map(([id]) => id);
